var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('img',{staticClass:"image-element",class:[
      _vm.displayClass,
      {'image-element--mod-not-draggable': !_vm.draggable}
    ],attrs:{"src":_vm.imgSrc,"alt":_vm.altText,"draggable":_vm.draggable},on:{"contextmenu":function($event){$event.preventDefault();return _vm.preventRightClick($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fb4ed0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ModuleImage/components/ImageElement/ImageElement.vue
// module id = null
// module chunks = 